import Text from 'components/elements/texts/Text'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import DOMAIN from 'constants/domains'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { getDomain } from 'utils/domain'

import AnimationModal from './AnimationModal'

/**
 * 情報モーダル
 */
const InformationModal: React.FC<InformationModalProps> = (props) => {
  const closeFunction = useCallback(() => {
    props.closeFunction && props.closeFunction()
  }, [])

  return (
    <AnimationModal
      on={props.on}
      type={props.top || props.bottom ? 'manual' : 'center'}
      manualTop={props.top}
      manualBottom={props.bottom}
      scrollLock={props.scrollLock}
      greyBack={props.greyBack}
      animationType="transparent"
      cursorPenetrate={props.cursorPenetrate}
      greyBackClose={props.greyBackClose}
      closeFunction={props.closeFunction}
    >
      <InformationModalArea
        fit={props.fit}
        topArrow={props.topArrow}
        modalFill={props.modalFill}
      >
        <InformationMessageArea textCenter={props.textCenter}>
          {props.content}
        </InformationMessageArea>
        {props.closeLabel && (
          <CloseArea onClick={closeFunction}>{props.closeLabel}</CloseArea>
        )}
      </InformationModalArea>
    </AnimationModal>
  )
}

type InformationModalProps = {
  on: boolean
  content: string | React.ReactNode
  scrollLock?: boolean
  greyBack?: boolean
  closeLabel?: string | React.ReactNode
  top?: string
  bottom?: string
  fit?: boolean
  topArrow?: boolean
  cursorPenetrate?: boolean
  modalFill?: boolean
  textCenter?: boolean
  closeFunction?: () => void
  greyBackClose?: boolean
}

const modalTop = {
  [DOMAIN.SAFIC]: '',
  [DOMAIN.SJ]: '44px',
}[getDomain()]

const topArrowPosition = {
  [DOMAIN.SAFIC]: '-22px',
  [DOMAIN.SJ]: '22px',
}[getDomain()]

const InformationModalArea = styled(Text)<{
  fit?: boolean
  topArrow?: boolean
  modalFill?: boolean
}>`
  ${(props): string => (props.fit ? 'max-' : '')}width: calc(100vw - 88px);

  margin-top: ${modalTop};
  padding: 24px 24px 12px 24px;
  color: var(--color-modal-text);
  font-size: 14px;
  line-height: 2em;
  background: ${(props): string =>
    props.modalFill
      ? CLIENT_SETTINGS.colors.modalBackground
      : `${CLIENT_SETTINGS.colors.modalBackground}CC`};
  border-radius: 6px;

  ${(props): string =>
    props.topArrow
      ? `
    &:before {
      position: absolute;
      top: ${topArrowPosition};
      left: 50%;
      margin-left: -8px;
      border: 8px solid transparent;
      border-bottom: 14px solid ${CLIENT_SETTINGS.colors.modalBackground}CC;
      content: '';
    }
  `
      : ''}
`

const InformationMessageArea = styled.div<{
  textCenter?: boolean
}>`
  margin-bottom: 12px;
  ${(props): string => (props.textCenter ? 'text-align: center;' : '')}
`

const CloseArea = styled.div`
  margin-top: 24px;
  padding-top: 4px;
  font-size: 16px;
  text-align: center;
  border-top: 1px solid ${CLIENT_SETTINGS.colors.modalText}CC;
`

export default React.memo<InformationModalProps>(InformationModal)
